module.exports = __webpack_public_path__ + "static/media/gri3.dccbf52d.jpg";